import { render, staticRenderFns } from "./InstallPwaModal.vue?vue&type=template&id=6bf1adb7&scoped=true&"
import script from "./InstallPwaModal.vue?vue&type=script&lang=js&"
export * from "./InstallPwaModal.vue?vue&type=script&lang=js&"
import style0 from "./InstallPwaModal.vue?vue&type=style&index=0&id=6bf1adb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf1adb7",
  null
  
)

export default component.exports